import { Avatar, Typography } from "@mui/material";
import useColors from "../../api/hooks/useColors";

const TenantAvatar = ({ tenant, size = 16 }) => {
  const colors = useColors();

  // Define the tenant avatar colors from the theme
  const tenantAvatarColors = [
    {
      backgroundColor: colors.tenant_avatar_bg_dark_green,
      fontColor: colors.common_white,
    },
    {
      backgroundColor: colors.tenant_avatar_bg_light_green,
      fontColor: colors.tenant_avatar_font_color_dark,
    },
    {
      backgroundColor: colors.tenant_avatar_bg_red,
      fontColor: colors.tenant_avatar_font_color_dark,
    },
    {
      backgroundColor: colors.tenant_avatar_bg_orange,
      fontColor: colors.tenant_avatar_font_color_dark,
    },
    {
      backgroundColor: colors.tenant_avatar_bg_yellow,
      fontColor: colors.tenant_avatar_font_color_dark,
    },
    {
      backgroundColor: colors.tenant_avatar_bg_bluish_grey,
      fontColor: colors.common_white,
    },
    {
      backgroundColor: colors.tenant_avatar_bg_purple,
      fontColor: colors.common_white,
    },
    {
      backgroundColor: colors.tenant_avatar_bg_mustard,
      fontColor: colors.tenant_avatar_font_color_dark,
    },
    {
      backgroundColor: colors.tenant_avatar_bg_peach,
      fontColor: colors.tenant_avatar_font_color_dark,
    },
    {
      backgroundColor: colors.tenant_avatar_bg_teal,
      fontColor: colors.tenant_avatar_font_color_dark,
    },
  ];

  // Get colors based on the tenant's customer_id
  const getColorsFromCustomerId = () => {
    if (!tenant?.customer_id) return tenantAvatarColors[0];

    // Convert customer_id to a number to use as index
    let sum = 0;
    const id = tenant.customer_id.toString();
    for (let i = 0; i < id.length; i++) {
      sum += id.charCodeAt(i);
    }

    // Use modulo to get an index within the array bounds
    const colorIndex = sum % tenantAvatarColors.length;
    return tenantAvatarColors[colorIndex];
  };

  const { backgroundColor, fontColor } = getColorsFromCustomerId();

  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        bgcolor: backgroundColor,
        padding: size > 20 ? 1 : 0.5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* Show the two first letters of the tenant's company name */}
      <Typography
        variant="overline"
        sx={{
          fontSize: `${size / 2.5}px`,
          lineHeight: 1,
          color: fontColor,
          padding: 0,
          margin: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {tenant.company_name?.length > 1
          ? tenant.company_name.substring(0, 2)
          : tenant.company_name?.charAt(0)}
      </Typography>
    </Avatar>
  );
};

export default TenantAvatar;
